import { FC, useMemo, useCallback, useRef, useEffect } from 'react'
import { AdvisorRequestPanePreset } from 'components/features/coaching/advisorMeeting/AdvisorRequestPanePreset/AdvisorRequestPanePreset'
import { AdvisorMeetingWizardNonRegularSpecificFields } from 'components/features/coaching/advisorMeeting/types/requests'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { SubscriptionMessageOverlay } from 'components/features/pfm/SubscriptionMessageOverlay/SubscriptionMessageOverlay'
import { RegisterForm } from 'components/molecules/forms/RegisterForm'
import styles from 'components/features/coaching/advisorMeeting/AdvisorRequestSignup/AdvisorRequestSignup.styl'
import { change, isSubmitting as isSubmittingSelector } from 'redux-form'
import { FORM_ONBOARDING_REGISTER } from 'constants/forms'
import { ENFORCE_POLICY_AGREEMENT } from 'constants/onboarding'
import Button from 'components/features/pfm/Button/Button'

type AdvisorRequestSignupProps = {
  fields: AdvisorMeetingWizardNonRegularSpecificFields
  onClose: () => void
}
export const AdvisorRequestSignup: FC<AdvisorRequestSignupProps> = (props) => {
  const { fields, onClose } = props
  const isLoading = useStoreSelector((state) => state.data.subscription.stripeCreatePaymentMethod.isLoading)
  const isSubmitting = useStoreSelector((state) => isSubmittingSelector(FORM_ONBOARDING_REGISTER)(state))

  const dispatch = useStoreDispatch()
  useEffect(() => {
    if (fields.flow !== 'landing') {
      return
    }

    const { income, zip5 } = fields
    dispatch(change(FORM_ONBOARDING_REGISTER, 'income', income))
    dispatch(change(FORM_ONBOARDING_REGISTER, 'zip5', zip5))
  }, [dispatch, fields])

  const messageChild = useMemo(() => (
    <SubscriptionMessageOverlay />
  ), [])

  const formRef = useRef<any>(null) // TODO! fix any

  const handleSubmit = useCallback(() => {
    if (!formRef.current) {
      return
    }
    formRef.current.wrappedInstance.handleSubmit({ preventDefault: () => { /* do nothing */ } } as any)
  }, [])

  return (
    <AdvisorRequestPanePreset
      title='Schedule a New Coaching Session'
      subTitle='Create your account'
      progressBarPercent={ 90 }
      isLoading={ isLoading }
      notification={ messageChild }
      onCancel={ onClose }
      onFooterCancel={ null }
    >
      <div className={ styles.content }>
        <RegisterForm mode='meeting-panel' ref={ formRef } />
        <div className={ styles.submitButton }>
          <Button onClick={ handleSubmit } fullWidth size='medium' isSubmitting={ isSubmitting }>Continue</Button>
        </div>
        { ENFORCE_POLICY_AGREEMENT ? null : (
          <div className={ styles.termsInvitation }>
            By creating an account, you agree to the Status<br />
            <a href='/terms' target='_blank'>
              <span className={ styles.link }>Terms &amp; Conditions</span>
            </a>
            <span> and </span>
            <a href='/privacy' target='_blank'>
              <span className={ styles.link }>Privacy Policy</span>
            </a>.
          </div>
        ) }
      </div>
    </AdvisorRequestPanePreset>
  )
}
